import type { IntegrationProvider } from './types';

const googleCalendarProvider: IntegrationProvider = {
  key: 'google-calendar',
  label: 'Google Calendar',
  capabilities: {
    supportsFieldMapping: false,
    supportsRoleMapping: false,
    supportsRelationshipMapping: false,
    supportsWriteback: false,
  },
  flowKeys: {
    firstSync: {
      accounts: '',
      contacts: '',
      companies: '',
      conversation_messages: 'first-sync-for-meetings',
    },
    receive: {
      accounts: '',
      contacts: '',
      companies: '',
      conversation_messages: 'receive-meeting-events',
    },
    send: {
      accounts: '',
      contacts: '',
      companies: '',
      conversation_messages: '',
    },
  },
  supportedObjects: ['meetings'],
  activatableObjects: ['meetings'],
  defaultSourceCollections: {
    meetings: 'events',
  },
};

export default googleCalendarProvider;
